import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import type { ComponentProps } from 'react'
import { Skeleton } from '~/components/ui/skeleton'
import { cn } from '~/lib/utils'

export const EventDateBadge = ({
	date,
	timezone,
	altStyle,
	size = 'sm',
	...props
}: {
	date: string
	timezone?: string
	altStyle?: boolean
	size?: 'sm' | 'lg'
} & ComponentProps<'div'>) => {
	const day = dateTimeUtils(date).tz(timezone)

	return (
		<div
			{...props}
			className={cn(
				'flex size-[67px] shrink-0 flex-col items-center justify-center rounded font-bold',
				altStyle ? 'bg-white' : 'bg-slate-200/30',
				{ 'md:size-[100px]': size === 'lg' },
				props.className,
			)}
			style={{
				printColorAdjust: 'exact',
				WebkitPrintColorAdjust: 'exact',
			}}
		>
			<div
				className={cn('!leading-none text-3xl', {
					'md:text-5xl': size === 'lg',
				})}
			>
				{day.format('D')}
			</div>

			<div className='text-lg capitalize leading-none'>{day.format('MMM')}</div>
		</div>
	)
}

EventDateBadge.skeleton = () => <Skeleton className='h-[67px] w-[67px]' />
